/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unpin_MessageInputs */

const en_unpin_message = /** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpin Message`)
};

const es_unpin_message = /** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfijar Mensaje`)
};

const fr_unpin_message = /** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désépingler le message`)
};

const de_unpin_message = /** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht loslösen`)
};

const id_unpin_message = /** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepas Sematan Pesan`)
};

/** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */
const ja_unpin_message = en_unpin_message;

/** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */
const zh_unpin_message = en_unpin_message;

/** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */
const ar_unpin_message = en_unpin_message;

/** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */
const it_unpin_message = en_unpin_message;

/** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */
const ru_unpin_message = en_unpin_message;

/** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */
const pt_unpin_message = en_unpin_message;

/** @type {(inputs: Unpin_MessageInputs) => LocalizedString} */
const ko_unpin_message = en_unpin_message;

/**
* | output |
* | --- |
* | "Unpin Message" |
*
* @param {Unpin_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const unpin_message = /** @type {((inputs?: Unpin_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unpin_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unpin_message(inputs)
	if (locale === "es") return es_unpin_message(inputs)
	if (locale === "fr") return fr_unpin_message(inputs)
	if (locale === "de") return de_unpin_message(inputs)
	if (locale === "ja") return ja_unpin_message(inputs)
	if (locale === "zh") return zh_unpin_message(inputs)
	if (locale === "ar") return ar_unpin_message(inputs)
	if (locale === "id") return id_unpin_message(inputs)
	if (locale === "it") return it_unpin_message(inputs)
	if (locale === "ru") return ru_unpin_message(inputs)
	if (locale === "pt") return pt_unpin_message(inputs)
	return ko_unpin_message(inputs)
});